module.exports = __webpack_public_path__ + "img/Bike.63d6c467.svg";